import axios from "axios";

export default axios.create({
  // baseURL: "https://www.versatileapparels.com",
  // baseURL: "https://keshfashion.pythonanywhere.com",
  // baseURL: "http://127.0.0.1:8000",
  baseURL: "https://api.versatileapparels.com",
});


// kESH@2022